<template>
    <div class="page">
        <v-container grid-list-md class="">
            <h2 class="myTitle">Bestellung erfolgreich!</h2>

            <div class="spacer-10"></div>

            <div class="indented  text-center">
                <div class="icon icon--order-success svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                        <circle stroke="#50A92F" stroke-width="2" cx="36" cy="36" r="34" fill="none"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" fill="#50A92F"
                              d="M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z"></path>
                    </svg>
                    <!--                <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 72 72">-->
                    <!--                    <g fill="none" stroke="#6de623" stroke-width="2">-->
                    <!--                        <circle cx="36" cy="36" r="35"-->
                    <!--                                style="stroke-dasharray:240px, 240px; stroke-dashoffset: 480px;"></circle>-->
                    <!--                        <path d="M17.417,37.778l9.93,9.909l25.444-25.393"-->
                    <!--                              style="stroke-dasharray:50px, 50px; stroke-dashoffset: 0px;"></path>-->
                    <!--                    </g>-->
                    <!--                </svg>-->
                </div>
            </div>

            <div v-if="ready" class=" text-center">
                <div class="indented">
                    <div style="font-size: 3em">#{{order.orderNumber}}</div>
                    <div style="font-size: 1.4em;; opacity: 0">Für {{$store.state.user.name}}</div>
                </div>

                <div class="spacer-15"></div>

                <div>
<!--                    <h2 class="blinkText">Warte auf die Bestätigung</h2>-->
                    <div style="padding: 10px 25px" v-if="hasEmail">
                        Eine Bestätigung dieser Bestellung wurde an Deine E-Mail Adresse ({{userInfo.email}}) gesendet.
                    </div>
                </div>

                <div class="spacer-25"></div>

                <div class=" text-center">
                    <v-btn @click.native.passive="gotoDetails" class="text-none btn-df" >Bestelldetails</v-btn>
                    <!--                <v-btn @click.native.passive="gotoDetails">Bestelldetails</v-btn>-->
                </div>

            </div>
            <div class="spacer-25"></div>
        </v-container>




<!--        <qsignal class="hide-md"></qsignal>-->

    </div>
</template>

<script>
    import store from '../store/store'
    import {ebus} from '../vendor/ebus';
    import {jumpToTop} from "@/vendor/util";

    export default {
        components: {},
        data() {
            return {
                order: {},
                ready: false,
            }
        },
        computed: {
            hasEmail() {
                try {
                    return !!this.userInfo.email;
                } catch (e) {
                    return false;
                }
            }
        },

        mounted() {
            setTimeout(()=>{
                store.commit('showLoading', false);
            },400);
            // jumpToTop();
            // store.commit('currentRoute', 'orderSuccess');
            this.init();

            //auto navigate to detail
            setTimeout(() => {
                let rn = this.$route.name;
                if (rn.indexOf('Bestaetigung') !== -1) {
                    this.gotoDetails();
                }
            }, 12 * 1000);
        },

        methods: {
            init() {
                let lastOrder = this.$ls.get('lastOrder',false);
                if (lastOrder) {
                    this.order = lastOrder;
                    this.ready = true;
                }

                ebus.$emit('orderSuccess');
            },

            gotoDetails() {
                this.$router.push({name: 'Bestellung', params: {uniqueOrderId: this.order.uniqueOrderId}});
            }
        }
    }
</script>

<style lang="scss" scoped>
    /*@import '../styles/sharedStyles';*/

    .icon--order-success svg path {
        -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;
        animation: checkmark 0.25s ease-in-out 0.7s backwards
    }

    .icon--order-success svg circle {
        -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;
        animation: checkmark-circle 0.6s ease-in-out backwards
    }

</style>
